<script setup lang="ts">
// 郵便番号から住所を検索可能なフォーム
interface Props {
  postnum?: string;
  address?: string;
  address_number?: string;
  required?: boolean;
}

const id_post = useUid();
const id_address = useUid();
const id_address_number = useUid();

const props = withDefaults(defineProps<Props>(), {
  postnum: "",
  address: "",
  address_number: "",
  required: false,
});

const emit = defineEmits<{
  "update:postnum": [value: string];
  "update:address": [value: string];
  "update:address_number": [value: string];
}>();

// 郵便番号
const postNumber = computed({
  get() {
    return props.postnum;
  },
  set(newValue) {
    emit("update:postnum", newValue);
  },
});

// 住所
const addressText = computed({
  get() {
    return props.address;
  },
  set(newValue) {
    emit("update:address", newValue);
  },
});

// 番地
const addressNumber = computed({
  get() {
    return props.address_number;
  },
  set(newValue) {
    emit("update:address_number", newValue);
  },
});

// 郵便番号から検索した住所を入れる
function setAddress(e: string) {
  addressText.value = e;
}
</script>

<template>
  <FormZipCodeInput
    :id="id_post"
    v-model="postNumber"
    label2="例:1234567"
    :required="required"
    @on-search="setAddress"
  />
  <FormInput
    :id="id_address"
    v-model="addressText"
    label="住所"
    label2="例:大阪府高石市取石3丁目"
    placeholder="住所を入力"
    alert="住所をご入力ください"
    :required="required"
  />
  <FormInput
    :id="id_address_number"
    v-model="addressNumber"
    label="番地"
    label2="例:9番地55号"
    placeholder="住所の番地を入力"
    alert="住所の番地をご入力ください"
    :required="required"
  />
</template>
